import React from 'react';

const ModalContentSaveQuote = React.createClass({
    render() {
        return (
            <div>
                <p>Our systems show that your property is in a higher risk area of theft, therefore theft and malicious damage cover is excluded from this policy.</p>
            </div>
        );
    }
});

export default ModalContentSaveQuote;


/** WEBPACK FOOTER **
 ** ./src/components/Modals/Content/ModalTheftExclusion.js
 **/